import Actions from '../Types'

const initialState = {
  current: [
    {
      name: '',
      statuses: [],
      amount: 0,
      term: 0,
      status: null,
      validityJobetter: '',
    },
  ],
  completed: [],
  secure: {
    current: [
      {
        name: '',
        statuses: [],
        amount: 0,
        term: 0,
        status: null,
        validityJobetter: '',
        loanTypeId: sessionStorage.getItem('loan') === 'secure' ? 2 : 1,
        warrantyTypeId: null
      },
    ],
    completed: [],
  },
  unsecure: {
    current: [
      {
        name: '',
        statuses: [],
        amount: 0,
        term: 0,
        status: null,
        validityJobetter: '',
        loanTypeId: sessionStorage.getItem('loan') === 'secure' ? 2 : 1,
        warrantyTypeId: null
      },
    ],
    completed: [],
  },
  debtrefinancing: {
    current: [
      {
        name: '',
        statuses: [],
        amount: 0,
        term: 0,
        status: null,
        validityJobetter: '',
        loanTypeId: sessionStorage.getItem('loan') === 'secure' ? 2 : 1,
        warrantyTypeId: null
      },
    ],
    completed: [],
  },
  pending: true,
}

const StatusesReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case Actions.GETSTATUSES:
      return {
        ...state,
        ...payload
      }
    case Actions.GETSTATUS_CURRENT:
      return {
        ...state,
        pending: payload.pending,
        unsecure: {
          ...state.unsecure,
          current: payload.unsecure.current
        },
        secure: {
          ...state.secure,
          current: payload.secure.current
        },
        debtrefinancing: {
          ...state.debtrefinancing,
          current: payload.debtrefinancing.current
      }
    }
    case Actions.GETSTATUSES_COMPLETED:
      return {
        ...state,
        pending: payload.pending,
        secure: {
          ...state.secure,
          completed: payload.secure.completed
        },
        unsecure: {
          ...state.unsecure,
          completed: payload.unsecure.completed
        },
        debtrefinancing: {
          ...state.debtrefinancing,
          completed: payload.debtrefinancing.completed
      }
    }
    case Actions.INITIAL_GETSTATUSES:
      return initialState
    default:
      return state
  }
}

export default StatusesReducer
